import { PiSealCheckFill, PiTextAlignJustify } from "react-icons/pi";
import { fileUrl } from "../../../../services/config";
import { convertDate } from "../../../../utils/convertDate";
import { digitsThree } from "../../../../utils/price";
import { useRef } from "react";
import ExportModal from "../../modals/export-modal/ExportModal";

function OrderCard({
  data,
  getOrderInfo,
  utils,
  reGetData,
  showImages = true,
}) {
  const exportRef = useRef();
  return (
    <>
      <ExportModal ref={exportRef} productData={data} reGetData={reGetData} />
      <div className="bg-white dark:bg-gray-800 w-11/12 mx-auto rounded-xl border border-gray-200 dark:border-gray-700 shadow-[0_2px_8px_rgba(0,0,0,0.08)] dark:shadow-[0_2px_8px_rgba(0,0,0,0.3)]">
        <div className="flex items-center justify-between px-6 py-4">
          {data.paymentStatus === "done" ? (
            <>
              {utils ? (
                <div className="flex items-center gap-2">
                  <p className="text-green-500">
                    {
                      utils?.ORDER_PROCCESS_SHIPPING_STATUS[
                        data.proccessShipping
                      ]?.name
                    }
                  </p>
                </div>
              ) : null}
            </>
          ) : (
            <p className="text-red-500">عدم پرداخت</p>
          )}
          <div className="relative group">
            <PiTextAlignJustify
              size={30}
              className="shadow rounded-lg text-gray-600 dark:text-gray-200"
            />
            <ul className="absolute w-32 -left-12 text-sm cursor-pointer top-8 transition-all opacity-0 invisible group-hover:opacity-100 group-hover:visible flex items-center bg-white flex-col rounded-lg shadow">
              <li
                className="w-full text-center p-2 hover:bg-gray-200"
                onClick={() => getOrderInfo(data?._id)}
              >
                جزئیات و ویرایش
              </li>
              {data.paymentStatus === "done" ? (
                <li
                  className="w-full text-center p-2 hover:bg-gray-200"
                  onClick={() => exportRef.current.showModal()}
                >
                  تایید و پرینت
                </li>
              ) : null}
            </ul>
          </div>
        </div>
        <div className="border-t border-gray-200 dark:border-gray-700"></div>
        <div className="px-6 py-4">
          <p className="text-sm text-gray-500 dark:text-gray-50 break-all">بارکد : {data?.barcode || "-"}</p>
        </div>
        <div className="border-t border-gray-200 dark:border-gray-700"></div>
        <div className="flex flex-col gap-4 text-gray-500 dark:text-gray-50 px-6 py-5">
          <div className="flex gap-4">
            <p className="w-6/12 text-sm">
              تاریخ : {convertDate(data?.createdAt)}
            </p>
            <p className="w-6/12 text-sm">
              مبلغ : {digitsThree(data?.finalPrice)} تومان
            </p>
          </div>
          <div className="flex gap-4">
            <p className="w-6/12 text-sm">
              شماره سفارش : #{data?.trackingCode}
            </p>
            <p className="w-6/12 text-sm">
              تخفیف : {digitsThree(data?.totalDiscount)} تومان
            </p>
          </div>
          <div className="flex gap-4">
            <p className="w-6/12 text-sm">
              تاریخ : {convertDate(data?.paymentDate)}
            </p>
          </div>
          <div>
            <p className="text-sm break-words">
              ادرس :{" "}
              {data && `${data.province} - ${data.city} - ${data.address}`}
            </p>
          </div>
          <div className="flex gap-4">
            <p className="w-6/12 text-sm">
              مجموع تعداد نوع محصول : {data.products.length}
            </p>
            <p className="w-6/12 text-sm">
              مجموع تعداد اقلام :{" "}
              {data?.products?.reduce(
                (sum, item) => sum + (item.count || 0),
                0
              )}
            </p>
          </div>
          {data.linkCode || data.ref ? (
            <div className="flex gap-4">
              <p className="w-full text-sm">
                {data.linkCode ? (
                  <>
                    لینک ارجاع: {data.linkCode}
                    {data.ref && (
                      <> - نماینده: {data.ref?.name || ""} ({data.ref?.mobile || ""})</>
                    )}
                  </>
                ) : data.ref ? (
                  <>نماینده: {data.ref?.name || ""} ({data.ref?.mobile || ""})</>
                ) : null}
              </p>
            </div>
          ) : null}
          <div className="flex justify-end items-center pt-2">
            {data.paymentStatus === "done" ? (
              <p className="text-green-500 flex gap-2 items-center">
                {utils?.PAYMENT_STATUS[data.paymentStatus]?.name}
                <PiSealCheckFill size={28} className="text-green-500" />
              </p>
            ) : (
              <p>{utils?.PAYMENT_STATUS[data.paymentStatus]?.name}</p>
            )}
          </div>
        </div>
        {showImages ? (
          <div className="w-full flex flex-wrap gap-4 px-6 py-4">
            {data?.products?.length > 0 &&
              data?.products.map((item, index) => {
                return (
                  <img
                    key={index}
                    src={`${fileUrl}files/thumb_${item.product?.mainImage}`}
                    className="w-20 h-20 rounded-3xl"
                    alt=""
                  />
                );
              })}
          </div>
        ) : null}
      </div>
    </>
  );
}

export default OrderCard;
